
import { Component, inject } from "@angular/core";
import { MatFormFieldModule } from '@angular/material/form-field';
import { Router, RouterOutlet } from "@angular/router";
import { App } from "@capacitor/app";
import { Browser } from "@capacitor/browser";
import { AppwideAlertComponent } from "@shared/services/app-wide-alert/app-wide-alert.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [RouterOutlet, AppwideAlertComponent, MatFormFieldModule],
})
export class AppComponent {
  private router = inject(Router);

  /**
   * Constructor
   */
  constructor() {
    // App.addListener('appUrlOpen', async (event) => {
    //   const url = event.url;
    //   console.log("Deep link received:", url);
    //   if (url.includes('digilocker')) {
    //     // close custom tab
    //     await Browser.close();
    //     // navigate back to Angular screen
    //     this.router.navigate(['/public-digilocker-callback']);
    //   }
    // });

    // App.addListener('appUrlOpen', (event: any) => {
    //   const url = event.url;
    //   console.log("Deep link received in app component:", event);

    //   if (url.includes('digilocker-callback')) {

    //     // await Browser.close();

    //     const params = new URL(url).searchParams;

    //     const entityValue = params.get('entityValue');
    //     const widgetId = params.get('widgetId');

    //     this.router.navigate(['/public-digilocker-callback']);
    //   }
    // });

    App.addListener('appUrlOpen', async (event: any) => {

      console.log('Deep link event:', event);

      if (!event.url) return;

      // safer parsing
      const parsed = new URL(event.url);

      if (parsed.host === 'digilocker-callback') {

        // close browser
        await Browser.close();

        const params = parsed.searchParams;

        this.router.navigate(['/public-digilocker-callback'], {
          queryParams: {
            widgetId: params.get('widgetId'),
            entityValue: params.get('entityValue')
          }
        });
      }
    });
  }
}
